export default __webpack_public_path__ + "static/media/movies.81a438db.gif";